import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalDataLayerEvent, GlobalDataLayerService } from '@fedex/global-data-layer-client';
import { GdlPayload } from '../../models/LoginInfoResponse';

@Injectable({
  providedIn: 'root'
})
export class GdlService {
  serverErrorType = 'server';
  uiErrorType = 'validation';
  error = 'error';
  appName = 'wpro';
  interactionType = 'interaction';
  clickEvent = 'click';

  constructor(private gdlService: GlobalDataLayerService) { }

  // Handles the success event sent to GDL
  captureInteractionEvent(eventType: string, eventValue: string): void {
    const payload = { name: `${this.appName}-${eventType}`, value: eventValue };
    this.triggerGdlLogEvent(this.interactionType, this.clickEvent, payload);
  }

  // Handles the error message for both server and UI validation which sent to GDL
  captureGdlErrorMessages(payloadType: string, httpError?: HttpErrorResponse | any, httpMethodType?: string, formControlName?: string): void {
    let payload = {};
    let gdlErrorMessage = '';
    if (httpError && (httpError.errorMessage || httpError.statusText)) {
      gdlErrorMessage = httpError.error && httpError.error.errors && httpError.error.errors.length > 0 ?
        this.getGdlErrorMessage(httpError) : httpError.errorMessage ? httpError.errorMessage : httpError.statusText;
    }
    if (payloadType === this.serverErrorType) {
      payload = { type: payloadType, source: httpError.url, message: gdlErrorMessage, context: httpMethodType };
    } else if (payloadType === this.uiErrorType) {
      payload = { type: payloadType, source: formControlName, message: httpError };
    }
    // this.triggerGdlLogEvent(this.error, this.error, payload);
    this.payloadCheck(payload);
  }

  //validating payload value passed to gdl trigger
  payloadCheck(payload: any): void {
    if (payload.type && payload.message && payload.source) {
      this.triggerGdlLogEvent(this.error, this.error, payload);
    }
  }

  // returns the server error message
  getGdlErrorMessage(httpError: HttpErrorResponse): string {
    let gdlErrorMessage = '';
    httpError.error.errors.forEach((element) => {
      gdlErrorMessage += element.code;
    });
    return gdlErrorMessage;
  }

  // Triggers GDL log event
  triggerGdlLogEvent(categoryName: string, formName: string, payload: GdlPayload): void {
    const gdlEvent: GlobalDataLayerEvent = {
      category: categoryName, name: formName,
      payload
    };
    this.gdlService.logEvent(gdlEvent);
  }

}
